module.exports = __webpack_public_path__ + "static/media/marek_wolfryd_7.d636cfe3.jpg";